/* Clever Things – v2 interactions (no dependencies) */
(function () {
  var d = document, de = d.documentElement;
  de.classList.add('ct-js');

  /* right-click / long-press save menu off (forms stay usable) */
  d.addEventListener('contextmenu', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('input,textarea,[contenteditable="true"]')) return;
    e.preventDefault();
  });
  d.addEventListener('dragstart', function (e) { if (e.target && e.target.tagName === 'IMG') e.preventDefault(); });

  /* no widows fallback: join the last two words of text blocks */
  function noWidow(root) {
    var els = (root || d).querySelectorAll('.ct p, .ct h1, .ct h2, .ct h3, .ct li, .ct summary span, .ct figcaption, .ct-opt__s, .ct-page__body p, .ct-page__body li');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.dataset.nw) continue; el.dataset.nw = 1;
      var w = d.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), last = null, n;
      while ((n = w.nextNode())) { if (/\S/.test(n.nodeValue)) last = n; }
      if (!last) continue;
      var v = last.nodeValue.replace(/\s+$/, ''), k = v.lastIndexOf(' ');
      if (/\u00a0\S+$/.test(v) || v.slice(k + 1).indexOf('\u00a0') > -1) continue;
      if (k > 0 && v.slice(0, k).trim().length) last.nodeValue = v.slice(0, k) + ' ' + v.slice(k + 1) + (last.nodeValue.match(/\s+$/) || [''])[0];
    }
  }

  /* soft reveal on scroll */
  function reveal() {
    var items = d.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-in'); return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    for (var j = 0; j < items.length; j++) {
      var r = items[j].getBoundingClientRect();
      if (r.top < innerHeight * 0.96) items[j].classList.add('is-in'); else io.observe(items[j]);
    }
  }

  /* header: scrolled border, mobile menu */
  function header() {
    var h = d.querySelector('.ct-hdr'); if (!h) return;
    var on = function () { h.classList.toggle('is-scrolled', (window.scrollY || de.scrollTop) > 4); };
    on(); addEventListener('scroll', on, { passive: true });
    var m = d.getElementById('ct-menu'); if (!m) return;
    var open = function (v) { m.classList.toggle('is-open', v); de.classList.toggle('ct-lock', v); m.setAttribute('aria-hidden', v ? 'false' : 'true');
      d.querySelectorAll('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); });
      if (v) { var f = m.querySelector('[data-menu-close]'); f && f.focus(); } };
    d.querySelectorAll('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { open(true); }); });
    m.querySelectorAll('[data-menu-close], .ct-menu__nav a').forEach(function (b) { b.addEventListener('click', function () { open(false); }); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
  }

  /* announcement rotation on mobile */
  function ann() {
    var it = d.querySelectorAll('.ct-ann__i'); if (it.length < 2) return;
    var i = 0; it[0].classList.add('is-on');
    setInterval(function () { it[i].classList.remove('is-on'); i = (i + 1) % it.length; it[i].classList.add('is-on'); }, 4200);
  }

  /* gallery */
  function gallery() {
    d.querySelectorAll('[data-gal]').forEach(function (g) {
      var tr = g.querySelector('.ct-gal__track'), sl = tr.children, dots = g.querySelectorAll('.ct-gal__dots button'), th = g.querySelectorAll('.ct-gal__thumbs button'), cur = 0;
      var go = function (i, smooth) { i = Math.max(0, Math.min(sl.length - 1, i)); tr.scrollTo({ left: sl[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' }); };
      var mark = function (i) { cur = i; dots.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); }); th.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); }); };
      var t; tr.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { mark(Math.round(tr.scrollLeft / tr.clientWidth)); }, 60); }, { passive: true });
      dots.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
      th.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
      var p = g.querySelector('[data-prev]'), n = g.querySelector('[data-next]');
      p && p.addEventListener('click', function () { go(cur - 1); });
      n && n.addEventListener('click', function () { go(cur + 1); });
      g.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(cur - 1); if (e.key === 'ArrowRight') go(cur + 1); });
    });
  }

  /* bundle selector + add to cart */
  function buy() {
    var f = d.querySelector('[data-buy]'); if (!f) return;
    var fmt = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
    var opts = f.querySelectorAll('.ct-opt'), idIn = f.querySelector('input[name="id"]'), btns = d.querySelectorAll('[data-atc]');
    var sticky = d.querySelector('[data-sticky-sub]');
    var sel = function (o) {
      opts.forEach(function (x) { x.classList.toggle('is-on', x === o); });
      var r = o.querySelector('input'); r.checked = true; idIn.value = r.value;
      var p = +r.dataset.price, c = +r.dataset.cmp;
      btns.forEach(function (b) { var s = b.querySelector('[data-atc-price]'); if (s) s.textContent = fmt(p); });
      if (sticky) sticky.textContent = o.querySelector('.ct-opt__t').firstChild.textContent.trim() + ' · ' + fmt(p);
      try { var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u); } catch (e) {}
    };
    opts.forEach(function (o) { o.addEventListener('click', function (e) { e.preventDefault(); sel(o); }); o.querySelector('input').addEventListener('change', function () { sel(o); }); });
    var init = f.querySelector('.ct-opt input:checked'); if (init) sel(init.closest('.ct-opt'));
    var err = f.querySelector('.ct-buy__err');
    var add = function (e) {
      e.preventDefault();
      btns.forEach(function (b) { b.disabled = true; });
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: +idIn.value, quantity: 1 }], sections: 'ct-cart-drawer', sections_url: location.pathname })
      }).then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (j) {
          btns.forEach(function (b) { b.disabled = false; }); if (err) err.hidden = true;
          if (window.ctCart && j.sections && j.sections['ct-cart-drawer']) { ctCart.render(j.sections['ct-cart-drawer']); ctCart.open(true); }
          else location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        })
        .catch(function () { btns.forEach(function (b) { b.disabled = false; }); if (err) err.hidden = false; f.submit(); });
    };
    f.addEventListener('submit', add);
    var sb = d.querySelector('[data-sticky-atc]'); if (sb) sb.addEventListener('click', function (e) { e.preventDefault(); f.requestSubmit ? f.requestSubmit() : f.submit(); });
    /* sticky bar visibility */
    var st = d.querySelector('.ct-sticky'), main = f.querySelector('.ct-buy__atc');
    if (st && main && 'IntersectionObserver' in window) {
      var past = false, foot = d.querySelector('.ct-foot');
      new IntersectionObserver(function (en) { en.forEach(function (x) { past = !x.isIntersecting && x.boundingClientRect.top < 0; st.classList.toggle('is-on', past); }); }).observe(main);
      if (foot) new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) st.classList.remove('is-on'); else if (past) st.classList.add('is-on'); }); }).observe(foot);
    }
  }


  /* silent product loops: load when near, pause when away */
  function loops() {
    var vs = d.querySelectorAll('video[data-loop]'); if (!vs.length) return;
    var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var play = function (v) { if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if (!('IntersectionObserver' in window)) { if (!rm) vs.forEach(play); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { var v = x.target; if (x.isIntersecting) { if (!rm) play(v); } else if (!v.paused) v.pause(); });
    }, { rootMargin: '240px 0px', threshold: 0.01 });
    vs.forEach(function (v) { if (rm) { v.removeAttribute('autoplay'); v.pause(); } io.observe(v); });
  }

  /* cart drawer */
  function drawer() {
    var el = d.getElementById('ct-cd'); if (!el) return;
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var last = null;
    var open = function (v) {
      if (v) last = d.activeElement;
      el.classList.toggle('is-open', v); de.classList.toggle('ct-lock', v); el.setAttribute('aria-hidden', v ? 'false' : 'true');
      if (v) { var c = el.querySelector('.ct-cd__top [data-cd-close]'); if (c) setTimeout(function () { c.focus({ preventScroll: true }); }, 60); }
      else if (last && last.focus) last.focus({ preventScroll: true });
    };
    var render = function (html) {
      var t = d.createElement('div'); t.innerHTML = html;
      var ni = t.querySelector('[data-cd-inner]'), oi = el.querySelector('[data-cd-inner]');
      if (ni && oi) { oi.parentNode.replaceChild(ni, oi); noWidow(el); }
      var n = ni ? +ni.dataset.count : 0;
      d.querySelectorAll('[data-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
    };
    var busy = function (v) { el.classList.toggle('is-busy', v); };
    var post = function (url, body) {
      body.sections = 'ct-cart-drawer'; body.sections_url = location.pathname;
      return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); });
    };
    var apply = function (j) { if (j && j.sections && j.sections['ct-cart-drawer']) render(j.sections['ct-cart-drawer']); };
    var fail = function () { location.href = root + 'cart'; };
    window.ctCart = { open: open, render: render };
    d.addEventListener('click', function (e) {
      var t = e.target; if (!t.closest) return;
      if (t.closest('[data-cd-open]')) { e.preventDefault(); open(true); return; }
      if (t.closest('[data-cd-close]')) { e.preventDefault(); open(false); return; }
      var q = t.closest('[data-cd-q]');
      if (q) { e.preventDefault(); busy(true); post('cart/change.js', { id: q.dataset.key, quantity: +q.dataset.cdQ }).then(apply).catch(fail).then(function () { busy(false); }); return; }
      var u = t.closest('[data-cd-up]');
      if (u) { e.preventDefault(); busy(true);
        post('cart/change.js', { id: u.dataset.key, quantity: 0 })
          .then(function () { return post('cart/add.js', { items: [{ id: +u.dataset.to, quantity: 1 }] }); })
          .then(apply).catch(fail).then(function () { busy(false); }); }
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) open(false); });
    /* back/forward cache: refresh contents */
    addEventListener('pageshow', function (e) { if (e.persisted) fetch(root + '?sections=ct-cart-drawer').then(function (r) { return r.json(); }).then(function (j) { if (j['ct-cart-drawer']) render(j['ct-cart-drawer']); }).catch(function () {}); });
  }


  /* highlights carousel buttons */
  function hl() {
    d.querySelectorAll('.ct-hl').forEach(function (s) {
      var tr = s.querySelector('[data-hl]'); if (!tr) return;
      var step = function (dir) { var c = tr.querySelector('.ct-hl__c'); var w = c ? c.getBoundingClientRect().width + 16 : tr.clientWidth * 0.8; tr.scrollBy({ left: dir * w, behavior: 'smooth' }); };
      var p = s.querySelector('[data-hl-prev]'), n = s.querySelector('[data-hl-next]');
      p && p.addEventListener('click', function () { step(-1); }); n && n.addEventListener('click', function () { step(1); });
    });
  }

  /* accordions: only one open per group */
  function acc() {
    d.querySelectorAll('[data-acc]').forEach(function (g) {
      g.querySelectorAll('details').forEach(function (x) { x.addEventListener('toggle', function () { if (x.open) g.querySelectorAll('details[open]').forEach(function (y) { if (y !== x) y.open = false; }); }); });
    });
  }

  function init() { noWidow(); reveal(); header(); ann(); gallery(); drawer(); buy(); acc(); loops(); hl(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
